import { Star, Users, Clock, Trophy } from "lucide-react";
import styles from "./CourseHeader.module.css";

// Custom Badge Component
const Badge = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  return <span className={`${styles.badge} ${className}`}>{children}</span>;
};

// Custom Button Component  
const Button = ({ 
  children, 
  onClick, 
  className = "" 
}: { 
  children: React.ReactNode; 
  onClick?: () => void; 
  className?: string;
}) => {
  return (
    <button 
      className={`${styles.ctaButton} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

const CourseHeader = () => {
  return (
    <div className={styles.courseHeader}>
      <div className={styles.container}>
        <Badge>
          🔥 Premium Course
        </Badge>
        
        <h1 className={styles.title}>
          <span className={styles.titleViral}>VIRAL</span>{" "}
          <span className={styles.titleAgency}>AGENCY</span>{" "}
          <span className={styles.titleMethod}>METHOD</span>
        </h1>
        
        <p className={styles.subtitle}>
          Master the art of viral marketing and build your successful digital agency from scratch
        </p>

        <div className={styles.statsContainer}>
          <div className={styles.statItem}>
            <Star className={`${styles.statIcon} ${styles.statIconYellow}`} />
            <span>4.9/5 Rating</span>
          </div>
          <div className={styles.statItem}>
            <Users className={styles.statIcon} />
            <span>2,500+ Students</span>
          </div>
          <div className={styles.statItem}>
            <Clock className={styles.statIcon} />
            <span>8+ Hours Content</span>
          </div>
          <div className={styles.statItem}>
            <Trophy className={styles.statIcon} />
            <span>Certificate Included</span>
          </div>
        </div>

        <Button>
          Start Learning Now
        </Button>
      </div>
    </div>
  );
};

export default CourseHeader;